import VideoBlock from './VideoBlock.vue';

export default function install(Vue) {
  Vue.component(VideoBlock.name, VideoBlock)
}
